import monochromeIcon from "../../icons/monochromeIcon.svg"
import lowSaturationIcon from "../../icons/lowSaturationIcon.svg"
import highSaturationIcon from "../../icons/highSaturationIcon.svg"
import lightContrastIcon from "../../icons/lightContrastIcon.svg"
import darkContrastIcon from "../../icons/darkContrastIcon.svg"
import highContrastIcon from "../../icons/highContrastIcon.svg"

export default [
    {
        label: 'Monochrome',
        key: 'monochrome',
        icon: monochromeIcon,
    },
    {
        label: 'Low Saturation',
        key: 'low-saturation',
        icon: lowSaturationIcon,
    },
    {
        label: 'High Saturation',
        key: 'high-saturation',
        icon: highSaturationIcon,
    },
    {
        label: 'High Contrast',
        key: 'high-contrast',
        icon: highContrastIcon,
    },
    {
        label: 'Light Contrast',
        key: 'light-contrast',
        icon: lightContrastIcon,
    },
    {
        label: 'Dark Contrast',
        key: 'dark-contrast',
        icon: darkContrastIcon,
    },
];